import { render, staticRenderFns } from "./ContractOptionsClientArea.vue?vue&type=template&id=5bfde054&"
import script from "./ContractOptionsClientArea.vue?vue&type=script&lang=js&"
export * from "./ContractOptionsClientArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports